import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import styles from "../Settings.module.scss";
import { getRateCategories } from "api";
import { useEffect, useState } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Tile } from "components/UIComponents/Tile";
import { useNominalsBySubType } from "services/nominalsService";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "components/common/Loading";
import { useActiveDepartments } from "services/departmentService";
import { useActiveApplications } from "services/applicationService";
import { handleApiError } from "Helper";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};

  if (!values.departmentId) {
    errors.departmentId = "Department is required";
  }

  if (!values.code?.trim()) {
    errors.code = "Work Type Code is required";
  }

  if (!values.name?.trim()) {
    errors.name = "Work Type Name is required";
  }

  return errors;
};

const CustomDepartmentCode = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    visited,
    modified,
    valid,
    value,
    onChange,
    onFocus,
    onBlur,
    ...others
  } = fieldRenderProps;

  const { data: departments, loading } = useActiveDepartments();
  const [valueVat, setValueVat] = useState(null);

  useEffect(() => {
    if (value) {
      departments.map((item) => {
        if (item.departmentID === value) {
          setValueVat(item);
        }
      });
    }
  }, [value]);
  const onValueChange = React.useCallback(
    (e) => {
      setValueVat(e.value);
      onChange({
        value: e.value,
      });
    },
    [onChange]
  );

  return (
    <div onFocus={onFocus} onBlur={onBlur} className="d-flex flex-column">
      <Label className="label mt-1 mb-2 w-100">Department&nbsp;</Label>
      <ComboBox
        data={departments || []}
        className={`${styles["work-type-field-style"]}`}
        value={valueVat}
        iconClassName="wa"
        required={true}
        textField={"name"}
        onChange={onValueChange}
        placeholder={"Search Department"}
        loading={loading}
      />
      <label className={"k-checkbox-label"} htmlFor={others.id}>
        {others.label}
      </label>
    </div>
  );
};

const EditCategory = (props) => {
  const dispatch = useDispatch();
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [rateCategories, setRateCategories] = useState([]);
  const { data: incomeNominals } = useNominalsBySubType("ProfitAndLoss_Income");
  const { data: application } = useActiveApplications();
  const [profitAndLoss, setProfitAndLoss] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setProfitAndLoss(incomeNominals || []);
  }, [incomeNominals]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rateCategoriesData = await getRateCategories();
        setRateCategories(rateCategoriesData?.data?.data);
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const ADD_NEW = props.type === "addNew";

  const applicationObject = application?.find(
    (app) => app.appCode === props?.item?.appCode
  );

  const rateCategoryObject = rateCategories?.find(
    (rate) => rate.rateCategoryId === props?.item?.rateCategoryId
  );

  const defaultProfitCostObject = incomeNominals?.find(
    (nominal) => nominal.nominalRef === props?.item?.defaultProfitCost
  );

  const initialVals = ADD_NEW
    ? {}
    : {
        ...props.item,
        appCode: applicationObject,
        rateCategoryId: rateCategoryObject,
        defaultProfitCost: defaultProfitCostObject,
      };

  if (loading) {
    return <Spinner />;
  }
  return (
    <Dialog
      title={ADD_NEW ? "Add Work Type" : `Edit ${props?.item?.name}`}
      onClose={props.cancelEdit}
      className="dialog-xmd"
    >
      <Form
        onSubmit={props.onSubmit}
        initialValues={initialVals}
        validator={validateForm}
        render={(formRenderProps) => (
          <div className="d-flex flex-column h-100">
            <div
              style={{
                flex: "1 1 auto",
                overflowY: "auto",
              }}
            >
              <FormElement
                style={{
                  maxWidth: 1200,
                }}
              >
                <fieldset className="p-3 px-4">
                  <div className="px-3">
                    <Tile
                      heading="Work Types"
                      className="mb-1 px-4 pb-2 overflow-auto"
                    >
                      <div className="mb-3">
                        <Field
                          name={"departmentId"}
                          className={`${styles["work-type-field-style"]}`}
                          component={CustomDepartmentCode}
                        />
                        {submitAttempted &&
                          formRenderProps.errors?.departmentId && (
                            <div className="fs-sm my-1 text-danger">
                              <i>{formRenderProps.errors.departmentId}</i>
                            </div>
                          )}
                      </div>
                      <div className="mb-3">
                        <Label className="label mt-1 mb-2 w-100">
                          Work Type Code&nbsp;
                        </Label>
                        <Field
                          name={"code"}
                          component={Input}
                          className={`${styles["work-type-field-style"]}`}
                          maxLength={5}
                          placeholder={"Enter Code"}
                        />
                        {submitAttempted && formRenderProps.errors?.code && (
                          <div className="fs-sm my-1 text-danger">
                            <i>{formRenderProps.errors.code}</i>
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="label mt-1 mb-2 w-100">
                          Work Type Name&nbsp;
                        </Label>
                        <Field
                          name={"name"}
                          component={Input}
                          className={`${styles["work-type-field-style"]}`}
                          maxLength={40}
                          placeholder={"Enter Name"}
                        />
                        {submitAttempted && formRenderProps.errors?.name && (
                          <div className="fs-sm my-1 text-danger">
                            <i>{formRenderProps.errors.name}</i>
                          </div>
                        )}
                      </div>
                    </Tile>
                  </div>
                  <div className="px-3 mt-2 ">
                    <Tile
                      heading="Matter Default Values"
                      className="mb-1 px-4 pb-4 overflow-auto"
                    >
                      <div className="row mt-3">
                        <div className="col ">
                          <Label className="label">Application</Label>
                          <Field
                            wf={true}
                            isStyled={true}
                            className={`${styles["work-type-field-style"]}`}
                            iconClassName="wa"
                            textField="display"
                            data={application}
                            name={"appCode"}
                            placeholder={"Application"}
                            component={ComboBox}
                          />
                        </div>
                        <div className="col ">
                          <Label className="label">WIP Credit Limit</Label>
                          <Field
                            name="wipCreditLimit"
                            className={`${styles["work-type-field-style"]}`}
                            placeholder="0.00"
                            spinners={false}
                            format="n2"
                            component={NumericTextBox}
                          />
                        </div>
                        <div className="col ">
                          <Label className="label mt-1">Estimate Fee</Label>
                          <Field
                            className={`${styles["work-type-field-style"]}`}
                            name={"estimateFee"}
                            component={NumericTextBox}
                            placeholder="0.00"
                            spinners={false}
                            format="n2"
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col ">
                          <Label className="label mt-1  w-100">
                            Review Days&nbsp;
                          </Label>
                          <Field
                            className={`${styles["work-type-field-style"]}`}
                            name={"reviewDays"}
                            component={NumericTextBox}
                            spinners={false}
                            placeholder="Add Review Days"
                          />
                        </div>
                        <div className="col ">
                          <Label className="label">Disb Credit Limit</Label>
                          <Field
                            name="disbCreditLimit"
                            className={`${styles["work-type-field-style"]}`}
                            placeholder="0.00"
                            spinners={false}
                            format="n2"
                            component={NumericTextBox}
                          />
                        </div>

                        <div className="col ">
                          <Label className="label">
                            Default Profit Cost Nominal
                          </Label>
                          <Field
                            wf={true}
                            isStyled={true}
                            iconClassName="wa"
                            className={`${styles["work-type-field-style"]}`}
                            data={profitAndLoss}
                            textField="nominalName"
                            name={"defaultProfitCost"}
                            placeholder={"Default Profit Cost Nominal"}
                            component={ComboBox}
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col ">
                          <Label className="label ">Rate Category</Label>
                          <Field
                            wf={true}
                            isStyled={true}
                            className={`${styles["work-type-field-style"]}`}
                            placeholder={"Rate Category"}
                            iconClassName="wa"
                            name={"rateCategoryId"}
                            data={rateCategories}
                            textField={"rateCategoryName"}
                            component={ComboBox}
                          />
                        </div>
                        <div className="col ">
                          <Label className="label">Bill Credit Limit</Label>
                          <Field
                            name="billCreditLimit"
                            className={`${styles["work-type-field-style"]}`}
                            placeholder="0.00"
                            spinners={false}
                            format="n2"
                            component={NumericTextBox}
                          />
                        </div>

                        <div className="col "></div>
                      </div>
                    </Tile>
                    {ADD_NEW ? null : (
                      <div className="mt-3 mx-2">
                        <Field
                          defaultChecked={true}
                          name={"active"}
                          component={Checkbox}
                          label={"Active"}
                        />
                      </div>
                    )}
                  </div>
                </fieldset>
              </FormElement>
            </div>

            <div
              className="dialog-footer"
              style={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "0 1rem",
              }}
            >
              <Button
                className="common-btn bgBtnSecondary me-3"
                onClick={props.cancelEdit}
              >
                Cancel
              </Button>
              <SubmitButton
                className="me-3"
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
                isLoading={props.isSubmitting}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </div>
        )}
      />
    </Dialog>
  );
};

export default EditCategory;
